@if (environment.tools.length > 0) {
  <details>
    <summary>
      <div class="row justify-content-center">
        <div class="col-12">
          <div class="row">
            <div class="col-4">
              <hyperkit-typography variant="h5" align="left" color="primary">{{
                environment.name
              }}</hyperkit-typography>
            </div>
            <div class="col-7 badges">
              <hyperkit-badge
                variant="success"
                [text]="compat + ' Compatible'"
              ></hyperkit-badge>
              <hyperkit-badge
                variant="warning"
                [text]="partial + ' Partial'"
              ></hyperkit-badge>
              <hyperkit-badge
                variant="error"
                [text]="incompat + ' Incompatible'"
              ></hyperkit-badge>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              @if (environment.description.length > 0) {
                <hyperkit-typography
                  class="description"
                  variant="body"
                  size="sm"
                  align="left"
                  color="secondary"
                  >{{ environment.description }}</hyperkit-typography
                >
              }
            </div>
          </div>
        </div>
      </div>
    </summary>
    @if (environment.tools.length > 0) {
      <div class="content">
        <cyborg-section class="mx-0 px-0">
          <div class="row collection-container">
            <div class="col-lg-5 content">
              @for (tool of environment.tools; track tool) {
                <div
                  [ngClass]="{
                    selected: tool == selectedTool,
                    disabled:
                      tool.generatedContent?.length == 0 ||
                      (tool.generatedContent?.Hunt?.length == 0 &&
                        tool.generatedContent?.Behavior?.length == 0),
                  }"
                  (click)="populateContent(tool)"
                  class="k-hstack tools"
                >
                  <img
                    class="m-4"
                    height="30px"
                    width="30px"
                    [src]="getToolIcon(tool.product)"
                  />
                  <div class="tool-info">
                    <hyperkit-typography
                      variant="body"
                      size="sm"
                      align="left"
                      color="primary"
                      >{{ tool.name }}</hyperkit-typography
                    >
                    @if (
                      tool.generatedContent.Hunt?.length > 0 ||
                      tool.generatedContent.Behavior?.length > 0
                    ) {
                      <hyperkit-typography
                        variant="body"
                        size="sm"
                        align="left"
                        color="secondary"
                      >
                        {{ tool.compatible }} of
                        {{
                          tool.generatedContent.Hunt?.length +
                            tool.generatedContent.Behavior?.length
                        }}
                        queries compatible</hyperkit-typography
                      >
                    }
                    @if (
                      tool.generatedContent?.length == 0 ||
                      (tool.generatedContent?.Hunt?.length == 0 &&
                        tool.generatedContent?.Behavior?.length == 0)
                    ) {
                      <p class="compatibility">No content for tool</p>
                    }
                  </div>
                </div>
              }
            </div>
            <div class="col-12 col-lg-7 ml-auto tabs">
              <hyperkit-tab-bar variant="secondary" mode="underline">
                @if (
                  selectedTool.generatedContent?.Hunt &&
                  selectedTool.generatedContent.Hunt.length > 0
                ) {
                  <hyperkit-tab
                    text="Hunt Queries"
                    [selected]="
                      selectedTool.generatedContent?.Hunt &&
                      selectedTool.generatedContent.Hunt.length > 0
                    "
                  >
                    @for (
                      content of selectedTool.generatedContent.Hunt;
                      track content
                    ) {
                      <div class="py-3 px-3">
                        <div>
                          <hyperkit-typography
                            color="primary"
                            variant="emphasized"
                          >
                            {{ content.title }}
                          </hyperkit-typography>
                          <hyperkit-badge
                            variant="neutral"
                            text="{{ getReadableCategory(content.category) }}"
                          ></hyperkit-badge>
                          <hyperkit-icon
                            icon="copy"
                            (click)="onCopy(content.query)"
                            size="base"
                          ></hyperkit-icon>
                          @if (supportedTool(selectedTool.product)) {
                            <hyperkit-link
                              display="inline"
                              target="_blank"
                              (click)="trackOpenInTool()"
                              [href]="
                                getSearchURLForContent(
                                  selectedTool,
                                  content.query
                                )
                              "
                              size="sm"
                              variant="emphasized"
                              color="primary"
                              text="Open in {{ selectedTool.name }}"
                            ></hyperkit-link>
                          }
                          @if (content.missingFields.length > 0) {
                            <hyperkit-notice>
                              Field mapping is missing the following field(s):
                              @for (
                                field of content.missingFields;
                                track field;
                                let isLast = $last
                              ) {
                                <span
                                  >{{ field
                                  }}<span>{{ isLast ? '' : ', &nbsp;' }}</span>
                                </span>
                              }
                              . Finish configuration
                              <a
                                routerLink="/settings/environment/{{
                                  environment.id
                                }}/tool/{{ selectedTool.id }}"
                                >here</a
                              >
                              for full compatibility.
                            </hyperkit-notice>
                          }
                          <hyperkit-message
                            type="Warning"
                            text="Please review your form entries before submitting."
                            [closable]="true"
                            actionText="Review Now"
                          >
                          </hyperkit-message>
                          @if (
                            !content.matched &&
                            content.missingFields.length == 0
                          ) {
                            <hyperkit-notice>
                              Missing mapping for
                              {{ getReadableCategory(content.category) }}.
                              Create a field mapping for this category
                              <a
                                routerLink="/settings/environment/{{
                                  environment.id
                                }}/tool/{{ selectedTool.id }}"
                                >here</a
                              >.
                            </hyperkit-notice>
                          }
                          <hyperkit-code-block
                            [code]="content.query"
                            [copyable]="true"
                            (copied)="onCopy($event)"
                          ></hyperkit-code-block>
                          @if (
                            content?.deployment_requirements.searchable_data
                              ?.length
                          ) {
                            <div id="searchable-data">
                              <hyperkit-typography variant="emphasized"
                                >Searchable Data</hyperkit-typography
                              >
                              <hyperkit-typography
                                variant="body"
                                size="md"
                                color="secondary"
                              >
                                {{
                                  content?.deployment_requirements.searchable_data.join(
                                    ', '
                                  )
                                }}
                              </hyperkit-typography>
                            </div>
                          }
                          @if (
                            content?.deployment_requirements.deployment_steps
                              ?.length
                          ) {
                            <div id="deployment-steps">
                              <hyperkit-typography variant="emphasized"
                                >Deployment Steps</hyperkit-typography
                              >
                              <hyperkit-markdown
                                [md]="
                                  content?.deployment_requirements
                                    .deployment_steps
                                "
                              ></hyperkit-markdown>
                            </div>
                          }
                        </div>
                      </div>
                    }
                  </hyperkit-tab>
                }
                @if (
                  selectedTool.generatedContent?.Behavior &&
                  selectedTool.generatedContent.Behavior.length > 0
                ) {
                  <hyperkit-tab
                    text="Detection Rules"
                    [selected]="
                      !selectedTool.generatedContent?.Hunt ||
                      !(selectedTool.generatedContent.Hunt.length > 0)
                    "
                  >
                    @for (
                      content of selectedTool.generatedContent?.Behavior;
                      track content
                    ) {
                      <div class="py-3 px-3">
                        <div>
                          <hyperkit-typography
                            variant="emphasized"
                            align="left"
                            color="primary"
                            >{{ content.title }}</hyperkit-typography
                          >
                          <hyperkit-badge
                            class="badge"
                            variant="neutral"
                            text="{{ content.goal }}"
                          ></hyperkit-badge>
                          <hyperkit-badge
                            variant="neutral"
                            text="{{ getReadableCategory(content.category) }}"
                          ></hyperkit-badge>
                          <hyperkit-icon
                            icon="copy"
                            (click)="onCopy(content.query)"
                            size="base"
                          ></hyperkit-icon>
                          @if (supportedTool(selectedTool.product)) {
                            <hyperkit-link
                              display="inline"
                              target="_blank"
                              [href]="
                                getSearchURLForContent(
                                  selectedTool,
                                  content.query
                                )
                              "
                              size="sm"
                              variant="emphasized"
                              color="primary"
                              text="Open in {{ selectedTool.name }}"
                            ></hyperkit-link>
                          }
                          @if (content.missingFields.length > 0) {
                            <hyperkit-notice>
                              Field mapping is missing the following field(s):
                              @for (
                                field of content.missingFields;
                                track field;
                                let isLast = $last
                              ) {
                                <span
                                  >{{ field
                                  }}<span>{{ isLast ? '' : ', &nbsp;' }}</span>
                                </span>
                              }
                              . Finish configuration
                              <a
                                routerLink="/settings/environment/{{
                                  environment.id
                                }}/tool/{{ selectedTool.id }}"
                                >here</a
                              >
                              for full compatibility.
                            </hyperkit-notice>
                          }
                          @if (
                            !content.matched &&
                            content.missingFields.length == 0
                          ) {
                            <hyperkit-notice>
                              Missing mapping for
                              {{ getReadableCategory(content.category) }}.
                              Create a field mapping for this category
                              <a
                                routerLink="/settings/environment/{{
                                  environment.id
                                }}/tool/{{ selectedTool.id }}"
                                >here</a
                              >.
                            </hyperkit-notice>
                          }
                          <hyperkit-code-block
                            [code]="content.query"
                            [copyable]="true"
                            (copied)="onCopy($event)"
                          ></hyperkit-code-block>
                          @if (
                            content?.deployment_requirements.searchable_data
                              ?.length
                          ) {
                            <div id="searchable-data">
                              <hyperkit-typography variant="emphasized"
                                >Searchable Data</hyperkit-typography
                              >
                              <hyperkit-typography
                                variant="body"
                                size="md"
                                color="secondary"
                              >
                                {{
                                  content?.deployment_requirements.searchable_data.join(
                                    ', '
                                  )
                                }}
                              </hyperkit-typography>
                            </div>
                          }
                          @if (
                            content?.deployment_requirements.deployment_steps
                              ?.length
                          ) {
                            <div id="deployment-steps">
                              <hyperkit-typography variant="emphasized"
                                >Deployment Steps</hyperkit-typography
                              >
                              <hyperkit-markdown
                                [md]="
                                  content?.deployment_requirements
                                    .deployment_steps
                                "
                              ></hyperkit-markdown>
                            </div>
                          }
                        </div>
                      </div>
                    }
                  </hyperkit-tab>
                }
              </hyperkit-tab-bar>
            </div>
          </div>
        </cyborg-section>
      </div>
    }
  </details>
}
